

























































































import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'CnabReturnsUploadListTable',
  props: {
    items: { type: Array, require: true }
  },
  data() {
    return {
      files: {
        headers: [
          {
            text: "Status",
            value: "status",
            sortable: false,
          },
          {
            text: "Tipo",
            value: "type",
            sortable: false,
          },
          {
            text: "Data da Importação",
            value: "date_record",
            sortable: false,
          },          
          {
            text: "Empresa",
            value: "name",
            sortable: false,
          },
          {
            text: "Arquivo",
            value: "filename",
            sortable: false,
          },          
          {
            text: "Situação",
            value: "situation",
            sortable: false,
          },
          {
            text: "Mensagem",
            value: "message",
            sortable: false,
          },
          {
            text:"",
            value:"actions",
            sortable: false,
          }       
        ]
      }
    };
  },
  methods: {
    handleDownload(value) {
      this.$emit('downloadFile', value);
    },
    handleRerunFile(value) {
      this.$emit('rerun-file', value);
    },
  },
});
